// RSA加密
import { JSEncrypt } from 'jsencrypt'

const pubKey = `
-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDI5kmdW9rmxQlTraZ6Wx+C7kYR
DjL332N53dsqFsqqT+PX6mosaM5hW4MS4vUbQNtUblhmQgzmUD0KBJFH9YZMmSPL
dCC+G4r7d2PPFBrCy+9dFUMUNaT4PenyaVQJyAp3bhUJ7n93bRJT9jtxsdDwJ/Zl
12A/kO93fr7+waaepwIDAQAB
-----END PUBLIC KEY-----
`;

const enscrypt_RSA = {
  /**
   * RSA加密
   * @param {string} text 需要加密的文本
   * @returns {string} 加密后的文本
   */  
  toRSAcode (text) {
    // 新建JSEncrypt对象
    let encryptor = new JSEncrypt();
    // 设置公钥
    encryptor.setPublicKey(pubKey);
    // 加密数据
    const resultText = encryptor.encrypt(text);
    // 转码
    return encodeURIComponent(resultText);
  }
}

export default enscrypt_RSA


// WEBPACK FOOTER //
// ./src/common/encrypt.js